namespace TabAurous.ECommerce {
    export namespace ProductWiseSalesService {
        export const baseUrl = 'ECommSales/ProductWiseSales';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommSales/ProductWiseSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ProductWiseSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
